import React from 'react';

import './StarRating.scss';

type StarRatingComponentProps = {
  id: string;
  stars: number[];
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function StarRating({ id, stars, name, onChange }: StarRatingComponentProps) {
  const initMap = stars.reduce((acc, star) => {
    acc[star] = false;
    return acc;
  }, {});
  const [valueMap, setValueMap] = React.useState(initMap);

  const onClickHandler = (event) => {
    const rank = parseInt(event.currentTarget.value);
    const newValueMap = { ...valueMap };
    newValueMap[event?.currentTarget.id] = !valueMap[event?.currentTarget.id];
    for (const key of Object.keys(newValueMap)) {
      if (parseInt(key) > rank) {
        newValueMap[key] = false;
      } else if (parseInt(key) <= rank) {
        newValueMap[key] = true;
      }
    }
    setValueMap(newValueMap);
  };

  return (
    <div id={id} className={'starRating'}>
      {Object.keys(valueMap).map((key) => (
        <input
          id={key}
          type="radio"
          name={name ?? 'star-rating'}
          className={`star ${valueMap[key] ? 'star-active' : ''}`}
          onClick={(event) => onClickHandler(event)}
          onChange={(event) => onChange(event)}
          value={key}
        />
      ))}
    </div>
  );
}

export default StarRating;
